import "../../../css/skeletonLoader.css";

const SkeletonLoader = ({ type }) => {
  return (
    <div className="skeleton-loader-container">
      {/* <div className="skeleton skeleton-title" />

      <div className="skeleton skeleton-input" />
      <div className="skeleton skeleton-input" />
      <div className="skeleton skeleton-input" />

      <div className="skeleton skeleton-button" />

      <div className="skeleton skeleton-card" />
      <div className="skeleton skeleton-card" /> */}

      {type === 1 &&
        Array.from({ length: 15 }).map((_, i) => (
          <div key={i} className="skeleton skeleton-main" />
        ))}
      {type === 2 &&
        Array.from({ length: 18 }).map((_, i) => (
          <div key={i} className="skeleton skeleton-left" />
        ))}
      {type === 3 &&
        Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="skeleton skeleton-input" />
        ))}
    </div>
  );
};

export default SkeletonLoader;
